import { useState,useEffect } from "react"
import { Container, Row, Col } from "react-bootstrap"
import { ArrowRightCircle } from "react-bootstrap-icons"
import headerImg from "../assets/image/myPicture.png"

export const Banner = () => {
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const toRotate = ["Software Developer", "Web Developer", "SQL Developer"];
    const [text, setText] = useState ('');
    const [delta, setDelta] = useState(300 - Math.random()*100);
    const period = 2000;

    useEffect(()=>{
        let ticker = setInterval(()=> {
            tick();
        },delta)

        return () => {clearInterval(ticker)};
    }, [text])

    const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length -1) : fullText.substring(0, text.length + 1);

        setText(updatedText);
        if (isDeleting) {
            setDelta(prevDelta => prevDelta /2)
        }
        if (!isDeleting && updatedText === fullText) {
            setIsDeleting(true);
            setDelta(period);
        }else if(isDeleting && updatedText === ''){
            setIsDeleting(false);
            setLoopNum(loopNum + 1);
            setDelta(500);
        }
    }
    return (
        <section className="banner" id="home">
            <Container>
                <Row className="align-items-center">
                    <Col xs = {12} md={6} xl = {7}>
                        <h1><b>{"Ryan Johnson"} </b><br></br><span className="warp">{text}</span></h1>
                        <p>Fully committed to the philosophy of life-long learning, I’m a developer with a deep passion for Software development and web development. 
                            The unique combination of creativity, logic, technology and never running out of new things to discover, drives my excitement and passion for programming. 
                            When I’m not at my computer I like to spend my time reading, playing disc golf and cooking.</p>
                            <a href="#connect" >
                                <button>Contact Me<ArrowRightCircle size={25} /> </button> 
                            </a>
                    </Col>
                    {/* 
                    <Col xs = {12} md={6} xl = {5}>
                        <img src={headerImg} alt="Header Img"></img>
                    </Col>
                    */}
                </Row>
            </Container>
            
        </section>
    )
}